<app-dialog-header headerText="Send Invitation" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="max-width: 500px;">
		<!-- <mat-form-field appearance="fill">
			<mat-label>Name</mat-label>
			<input matInput autocomplete="off" formControlName="InviteName">
			<mat-error *ngIf="dialogForm.get('InviteName')!.hasError('required')"><span>Name is required</span></mat-error>
		</mat-form-field> -->
		<mat-form-field appearance="fill">
			<mat-label>Email Address</mat-label>
			<input matInput autocomplete="off" formControlName="InviteEmail">
			<mat-error *ngIf="dialogForm.get('InviteEmail')!.hasError('required')"><span>Email is required</span></mat-error>
			<mat-error *ngIf="dialogForm.get('InviteEmail')!.hasError('email')"><span>A Valid Email is required</span></mat-error>
		</mat-form-field>
		<mat-form-field appearance="fill">
			<mat-label>Custom Message</mat-label>
			<input matInput autocomplete="off" formControlName="InviteMessage">
			<mat-error *ngIf="dialogForm.get('InviteMessage')!.hasError('required')"><span>Message is required</span></mat-error>
		</mat-form-field>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Invite as an admin</mat-label>
				<mat-slide-toggle #switchAdmin formControlName="InviteAsAdmin" color="primary"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value" 
			[disabled]="dialogForm.invalid || !dialogForm.dirty">Send</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
